// import { Space, Input, Flex, Button, Checkbox, Alert } from "antd";
// import { IconUser, IconLock } from "@tabler/icons-react";
// import styles from "./styles.module.css";
// import { useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import React, { useState } from 'react';
// const baseURL = `${process.env.REACT_APP_BACKEND_URL || ""}api/`;



// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }
// interface FormData {
//   email: string;
//   company_name: string;
//   acceptTerms: boolean;
//   plan: any;

// }

// const SignUp = () => {
//   const navigate = useNavigate();
//   const path= `${process.env.REACT_APP_BASE_URL || ""}`;
//   const image_path = path + "/images/header_logo.jpg";


//   const query = useQuery();
//   const [email, setEmail] = useState<string>('');
//   const [company_name, setcompany_name] = useState<string>('');
//   const [acceptTerms, setAcceptTerms] = useState<string>('');
//   const [error, setError] = useState<string | null>(null);
//   const [loading, setLoading] = useState<boolean>(false);
//   const plan = query.get('planCode');
//   const planPrice = query.get('planPrice');

//   const redirectToPlans = async () => {
//     navigate(path+'/auth/zoho');
//   };

//   const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     // Simple validation
//     if (!email) {
//       setError('Email field is required.');
//       return;
//     }
//     if (!company_name) {
//       setError('company_name field is required.');
//       return;
//     }
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!email || !emailRegex.test(email)) {
//       setError('Email should be valid');
//       return;
//     }
//     setError(null);
//     setLoading(true);
//     try {
//       // Example API call to backend
//       const response = await axios.post(baseURL+'signup', {email, company_name, plan});
//       console.log('User subscribed to selected plan successfully', response.data);
//       let subscribe_id = response.data.subscription_details;
//       navigate(path+`/auth/signup-confirmation`);
//     }  catch (error) {
//       // Handle error response from backend (e.g., wrong credentials)
//       if (axios.isAxiosError(error) && error.response) {
//         setError(error.response.data.message || 'Signup Failed');
//       } if (error.response.status === 422) {
//         setError(error.response.data);
//       }
//        else {
//         setError('An error occurred during login');
//       }
//     } finally {
//       setLoading(false);
//     }

//   };


//   return (
//     <Flex style={{ height: "70vh", justifyContent: "center", alignItems: "center", paddingTop: "40px" }}>
//       <Space direction="vertical" size="large" className={styles.side}>
//         <Space direction="vertical" size="small" className={styles.main}>
//           <img src={image_path} alt="logo" className={styles.logo} />
//           <p className={styles.leading}>Plan Selected : <span><strong>{plan}:</strong> {planPrice}</span></p>
//         </Space>
//         <form onSubmit={handleSubmit}>
//         {error && (
//           <div style={{marginBottom:"10px"}}>
//              <Alert message={error} type='error' closable />

//           </div>
//           )}
//           <Space direction="vertical" size="small" style={{marginBottom:"10px"}} className={styles.main}>
//             <p className={styles.leading}>Email</p>
//             <Input prefix={<IconUser size={18} />} size="large" name="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//                />
//           </Space>

//           <Space direction="vertical" size="small" style={{marginBottom:"10px"}} className={styles.main}>
//             <p className={styles.leading}>Company Name</p>
//             <Input type="text" size="large" name="company_name" value={company_name}
//               onChange={(e) => setcompany_name(e.target.value)}
//                />

//           </Space>
//           <Space direction="vertical" size="small" className={styles.main}>
//             <Checkbox id="terms" required > <label htmlFor="terms">I agree to the <a  target="_blank"  href="https://help.coexsys.com/coexsys-terms-of-use/">Terms of Use</a></label></Checkbox>
//           </Space>

//           <Flex justify="end">
//             <button type="submit" className={styles.submitbutton} disabled={loading}>{loading ? 'Activating 14 days trial...' : 'Activate 14 days trial'}</button>
//           </Flex>
//         </form>
//       </Space>
//     </Flex>
//   );

//   //   );
// };

// export default SignUp;

import React, { useState } from 'react';
import { Space, Input, Flex, Alert, Checkbox } from "antd";
import { IconUser } from "@tabler/icons-react";
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import styles from "./styles.module.css";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SignUp = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const path = `${process.env.REACT_APP_BASE_URL || ""}`;
  const baseURL = `${process.env.REACT_APP_BACKEND_URL || ""}api/`;
  const image_path = path + "/images/header_logo.jpg";

  const [formData, setFormData] = useState({
    email: '',
    company_name: '',
    acceptTerms: false
  });

  const [errors, setErrors] = useState({
    email: '',
    company_name: '',
    acceptTerms: '',
    general: ''
  });

  const [loading, setLoading] = useState(false);
  const plan = query.get('planCode');
  const planPrice = query.get('planPrice');

  const validateForm = () => {
    const newErrors = {
      email: '',
      company_name: '',
      acceptTerms: '',
      general: ''
    };

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    // Company name validation
    if (!formData.company_name) {
      newErrors.company_name = 'Company name is required';
    }

    // Terms acceptance validation
    if (!formData.acceptTerms) {
      newErrors.acceptTerms = 'You must accept the Terms of Use';
    }

    setErrors(newErrors);
    return !Object.values(newErrors).some(error => error !== '');
  };

  const handleInputChange = (e:any) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Clear error when user starts typing
    setErrors(prev => ({
      ...prev,
      [name]: '',
      general: ''
    }));
  };

  const handleSubmit = async (e:any) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(baseURL + 'signup', {
        email: formData.email,
        company_name: formData.company_name,
        plan
      });
      
      navigate(path + `/auth/signup-confirmation`);
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const serverErrors = error.response.data;
        
        // Handle Laravel validation errors
        if (error.response.status === 422) {
          const newErrors = {
            email: serverErrors.email?.[0] || '',
            company_name: serverErrors.company_name?.[0] || '',
            general: ''
          };
          setErrors(prev => ({ ...prev, ...newErrors }));
        } else {
          // Handle other errors
          setErrors(prev => ({
            ...prev,
            general: error.response.data.message || 'An error occurred during signup'
          }));
        }
      } else {
        setErrors(prev => ({
          ...prev,
          general: 'An unexpected error occurred. Please try again.'
        }));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex style={{ height: "70vh", justifyContent: "center", alignItems: "center", paddingTop: "40px" }}>
      <Space direction="vertical" size="large" className={styles.side}>
        <Space direction="vertical" size="small"  className={styles.main}>
        <img src={image_path} alt="logo" className={styles.logo} />
          <p  className={styles.leading}>
            Plan Selected: <span><strong>{plan}:</strong> {planPrice}</span>
          </p>
        </Space>

        <form onSubmit={handleSubmit} className="w-full">
          {errors.general && (
            <Alert
              message={errors.general}
              type="error"
              className="mb-4"
              closable
              onClose={() => setErrors(prev => ({ ...prev, general: '' }))}
            />
          )}

          <Space direction="vertical" size="small" className={styles.main}>
            <p className={styles.leading}>Email</p>
            <Input
              prefix={<IconUser size={18} />}
              size="large"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              status={errors.email ? 'error' : ''}
            />
            {errors.email && (
              <p className={styles.error}>{errors.email}</p>
            )}
          </Space>

          <Space direction="vertical" size="small"  className={styles.main}>
            <p className={styles.leading}>Company Name</p>
            <Input
              size="large"
              name="company_name"
              value={formData.company_name}
              onChange={handleInputChange}
              status={errors.company_name ? 'error' : ''}
            />
            {errors.company_name && (
              <p className={styles.error}>{errors.company_name}</p>
            )}
          </Space>

          <Space direction="vertical" size="small" className={styles.main}>
            <Checkbox
              name="acceptTerms"
              checked={formData.acceptTerms}
              onChange={handleInputChange}
            >
              <span className="text-sm">
                I agree to the <a href="https://help.coexsys.com/coexsys-terms-of-use/" target="_blank" rel="noopener noreferrer">Terms of Use</a>
              </span>
            </Checkbox>
            {errors.acceptTerms && (
              <p className={styles.error}>{errors.acceptTerms}</p>
            )}
          </Space>

          <button
            type="submit"
            className={styles.submitbutton}
            disabled={loading}
          >
            {loading ? 'Activating 14 days trial...' : 'Activate 14 days trial'}
          </button>
        </form>
      </Space>
    </Flex>
  );
};

export default SignUp;